import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { SVGIcon } from '@pearsontechnology/aero-components';
import { getIcon } from 'Workspace/helpers';
import {KnowledgeTypes} from 'constants/knowledgeMap';
import KnowledgeMapWarningPopover from 'builder/Knowledge/components/KnowledgeMapWarningPopover';
import {ROOT} from 'builder/Knowledge/components/TreeView/nodeTypes';
import { intl } from "containers/LanguageProvider/IntlGlobalProvider";
import messages from "./messages";
import KnowledgeMapInsertNode from '../KnowledgeMapInsertNode';
import {
  Container,
  ContainerWrapper,
  KnowledgeNameContainer,
  KnowledgeMapEmptyChildContainer,
  KnowledgeMapEmptyChildNameContainer,
  KnowledgeMapEmptyChildContainerWrapper,
  EnablingObjectiveAddNewLink,
  HumanCodingSchemeContainer,
  IconContainer,
  Actions,
  HoverActions,
  WarningIconContainer,
} from './styles';

function swallowEvent(event) {
  event.stopPropagation();
}

const getIconFromType = (itemType) => ({
  root: 'duotoneCircleTriple',
  group: 'duotoneCircleDouble',
  item: 'duotoneCircle',
}[itemType]);

function KnowledgeMapNode({ 
  item, 
  actions, 
  hoverActions, 
  itemType, 
  showWarningIcon, 
  theme, 
  isEmptyChildItem, 
  addNodeClickHandler, 
  isExpanded, 
  hasDummyChild, 
  ...props 
}) {
  const iconName = getIconFromType(itemType);
  const [showInsertNode, setShowInsertNode] = useState(false);
  const warningIconRef = useRef();
  const [show, setShow] = useState();

  const handleShowWarningPopover = (event) => {
    event.stopPropagation();
    setShow(!show);
  };

  const handleClosewWarningPopover = (event) => {
    event.stopPropagation();
    setShow(false);
  };

  const handleOnMouseEnter = () => {
    if(!isEmptyChildItem && !hasDummyChild){
      setShowInsertNode(true);
    }
  };

  const handleOnMouseLeave = () => {
    setShowInsertNode(false);
  };

  return (
    <ContainerWrapper {...props} onMouseEnter={() => handleOnMouseEnter()} onMouseLeave={()=>handleOnMouseLeave()}>
      {!isEmptyChildItem ? 
        <Container {...props}>
          { iconName && ( 
            <IconContainer>
              {itemType === ROOT && showWarningIcon && 
                <WarningIconContainer ref={warningIconRef} onClick={handleShowWarningPopover}>
                  <SVGIcon size="small" fill={theme['color.redDark']} icon={getIcon(KnowledgeTypes.WARNING_CIRCLE)} viewBox="0 0 24 24" /> 
                </WarningIconContainer>}
              {show && <KnowledgeMapWarningPopover 
                width= "400"
                referenceNode={warningIconRef.current}
                popperOptions={{ placement: 'right' }}
                offset="40px, 10px"
                show={show}
                onClose={handleClosewWarningPopover}
              /> }
              <SVGIcon icon={iconName} fill={theme['color.primary']} />
            </IconContainer>
          )}
          <KnowledgeNameContainer>
            { item.humanCodingScheme && !item.title && (
              <HumanCodingSchemeContainer>
                {item.humanCodingScheme}
              </HumanCodingSchemeContainer>
            )}
            {item.title || item.abbreviatedStatement || item.fullStatement}
          </KnowledgeNameContainer>
          { hoverActions && <HoverActions onClick={swallowEvent}>{hoverActions}</HoverActions>}
          { actions && <Actions onClick={swallowEvent}>{actions}</Actions>}
        </Container> : 
        <KnowledgeMapEmptyChildContainerWrapper>
          <KnowledgeMapEmptyChildContainer>
            <KnowledgeMapEmptyChildNameContainer>
              {intl.formatMessage(messages.competencyDocumentItemDragObjectiveText)}
              <EnablingObjectiveAddNewLink onClick={addNodeClickHandler}>
                {intl.formatMessage(messages.competencyDocumentItemDragObjectiveLinkText)}
              </EnablingObjectiveAddNewLink>
            </KnowledgeMapEmptyChildNameContainer>
          </KnowledgeMapEmptyChildContainer>
        </KnowledgeMapEmptyChildContainerWrapper>}
      {showInsertNode && <KnowledgeMapInsertNode isExpanded={isExpanded} addNodeClickHandler={addNodeClickHandler}/> }
    </ContainerWrapper>
  );
}

KnowledgeMapNode.propTypes = {
  itemType: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    humanCodingScheme: PropTypes.string,
    fullStatement: PropTypes.string,
    abbreviatedStatement: PropTypes.string,
  }),
  actions: PropTypes.any,
  hoverActions: PropTypes.func,
  theme: PropTypes.object,
  showWarningIcon: PropTypes.bool,
  isEmptyChildItem: PropTypes.bool,
};

KnowledgeMapNode.defaultProps = {
  itemType: 'item',
  isEmptyChildItem: false,
};

export default withTheme(KnowledgeMapNode);
